import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Navbar from './components/Navbar';
import MobileNavigation from './components/MobileNavigation';
import InstallPWA from './components/InstallPWA';
import { isStandalone } from './utils/isStandalone';
import Footer from './components/Footer';
import AgeVerification from './components/AgeVerification';
import Home from './pages/Home';
import PWAHome from './pages/PWAHome';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Login from './pages/Login';
import Signup from './pages/Signup';
import AdminDashboard from './pages/AdminDashboard';
import AdminProducts from './pages/AdminProducts';
import AdminOrders from './pages/AdminOrders';
import AdminUsers from './pages/AdminUsers';
import ProtectedRoute from './components/ProtectedRoute';
import './index.css';

function App() {
  const [ageVerified, setAgeVerified] = useState(false);
  const [showAgeModal, setShowAgeModal] = useState(false);
  const standalone = isStandalone();

  useEffect(() => {
    // Check if user has already verified their age on component mount
    const hasVerified = localStorage.getItem('ageVerified');
    if (hasVerified) {
      setAgeVerified(true);
    } else {
      setShowAgeModal(true);
    }
  }, []);

  const handleAgeVerification = () => {
    setAgeVerified(true);
    setShowAgeModal(false);
  };

  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
        <div className={`min-h-screen flex flex-col ${standalone ? 'pwa-mode' : 'web-mode'}`}>
          {/* Age Verification Modal - only show if needed */}
          {showAgeModal && (
            <AgeVerification onVerified={handleAgeVerification} />
          )}
          
          {ageVerified && (
            <>
              {/* Show different navigation based on standalone mode */}
              {!standalone && <Navbar />}
              {!standalone && <InstallPWA />}
              
              <main className="flex-grow">
                <Routes>
                  {/* Public Routes */}
                  <Route path="/" element={standalone ? <PWAHome /> : <Home />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/products/:id" element={<ProductDetail />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<Signup />} />
                  
                  {/* Protected Admin Routes */}
                  <Route path="/admin" element={
                    <ProtectedRoute adminOnly>
                      <AdminDashboard />
                    </ProtectedRoute>
                  } />
                  <Route path="/admin/products" element={
                    <ProtectedRoute adminOnly>
                      <AdminProducts />
                    </ProtectedRoute>
                  } />
                  <Route path="/admin/orders" element={
                    <ProtectedRoute adminOnly>
                      <AdminOrders />
                    </ProtectedRoute>
                  } />
                  <Route path="/admin/users" element={
                    <ProtectedRoute adminOnly>
                      <AdminUsers />
                    </ProtectedRoute>
                  } />
                </Routes>
              </main>

              {/* Show footer or mobile navigation based on standalone mode */}
              {standalone ? <MobileNavigation /> : <Footer />}
            </>
          )}
        </div>
        </Router>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
